import { render, staticRenderFns } from "./FixedShrink.vue?vue&type=template&id=b4bac80e&scoped=true&"
import script from "./FixedShrink.vue?vue&type=script&lang=js&"
export * from "./FixedShrink.vue?vue&type=script&lang=js&"
import style0 from "./FixedShrink.vue?vue&type=style&index=0&id=b4bac80e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bac80e",
  null
  
)

export default component.exports